import { Route, Routes as RoutesContainer } from 'react-router';

import { Log } from '../index';

const Routes = () => {
  return (
    <RoutesContainer>
      <Route exact path='/log' element={<Log />} />
    </RoutesContainer>
  );
};
export default Routes;
